"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageAlignmentClasses = exports.ImagePopoverTabs = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _alignments = require("./alignments");

var _ImageAlignmentClasse;

var ImagePopoverTabs = {
  CONTENT_TAB: 'CONTENT_TAB',
  STYLE_TAB: 'STYLE_TAB',
  LINK_TAB: 'LINK_TAB'
};
exports.ImagePopoverTabs = ImagePopoverTabs;
var ImageAlignmentClasses = (_ImageAlignmentClasse = {}, (0, _defineProperty2.default)(_ImageAlignmentClasse, _alignments.Alignments.CENTER, 'hs-image-align-center'), (0, _defineProperty2.default)(_ImageAlignmentClasse, _alignments.Alignments.LEFT, 'hs-image-align-left'), (0, _defineProperty2.default)(_ImageAlignmentClasse, _alignments.Alignments.RIGHT, 'hs-image-align-right'), (0, _defineProperty2.default)(_ImageAlignmentClasse, _alignments.Alignments.NONE, 'hs-image-align-none'), _ImageAlignmentClasse);
exports.ImageAlignmentClasses = ImageAlignmentClasses;